(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pta-adapter-specs"] && !Shopify.designMode) return;
  try {
    /**
   * Reports an opened dimensions dialog to analytics.
   *
   * ## Published, not sent
   *
   * `window.gtag` does not exist on this storefront. GA4 arrives through the Google & YouTube channel, which
   * Shopify runs as an app pixel inside a sandboxed iframe, so the measurement ID is only ever inside that
   * pixel's configuration and theme code cannot reach it.
   *
   * The finder is the cautionary tale: it called `gtag` directly, worked for about five years under Debut's
   * theme-level tag, and went quiet the moment analytics moved into the app pixel — with no error and no
   * visible fault, just a metric that flattened. So this does not call `gtag` even though it is the obvious
   * thing to reach for.
   *
   * `Shopify.analytics.publish` crosses into that sandbox. The "PTA Custom Events" pixel in the admin
   * subscribes to the name below and forwards it to GA4; without that pixel this call is a no-op, so the two
   * halves ship together or neither works.
   *
   * ## Capture, because `dialog:open` does not bubble
   *
   * Horizon constructs it as `new CustomEvent(type)` with no options, so `bubbles` is false and a listener on
   * `document` never sees it in the bubble phase. The capture phase runs from the root down to the target for
   * every event regardless, so a capturing listener does — and that avoids holding a reference to an element
   * that may not exist when this script runs.
   *
   * Bound to the dialog opening rather than the button being clicked. They amount to the same thing today,
   * since the button is behind the modal backdrop once open and cannot be clicked twice, but the question
   * being asked is how many people opened it.
   */
  document.addEventListener(
    'dialog:open',
    (event) => {
      const dialog = event.target;

      if (!(dialog instanceof HTMLElement) || dialog.id !== 'pta-dimensions-dialog') return;

      if (typeof window.Shopify?.analytics?.publish !== 'function') return;

      window.Shopify.analytics.publish('pta_dimensions_opened', {
        product_id: dialog.dataset.productId,
        product_handle: dialog.dataset.productHandle,
        length_mm: dialog.dataset.lengthMm,
        width_mm: dialog.dataset.widthMm,
        height_mm: dialog.dataset.heightMm,
      });
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pta-dyson-generations"] && !Shopify.designMode) return;
  try {
    (() => {
    const norm = (value) => value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    /* Placeholders are __code__ and __platform__ rather than braces: Shopify's parser ends an output tag
       at the first closing brace, even one inside a quoted string, and rejected the whole file on upload.
       Theme Check does not catch it. */
    const fill = (template, values) =>
      template.replace(/__([a-z]+)__/g, (match, key) => (key in values ? values[key] : match));

    const find = (gens, query) => {
      let best = null;
      for (const gen of gens) {
        for (const [list, excluded] of [[gen.fits, false], [gen.excluded, true]]) {
          for (const code of list) {
            const key = norm(code);
            if (!key) continue;
            if (key === query) return { gen, code, excluded };
            /* A longer typed code that starts with a listed one, e.g. a suffix printed on the label. */
            if (query.startsWith(key) && key.length >= 4 && (!best || key.length > norm(best.code).length)) {
              best = { gen, code, excluded };
            }
          }
        }
      }
      return best;
    };

    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const gens = JSON.parse(root.querySelector('[data-pta-dyson-data]').textContent);
      const input = root.querySelector('input');
      const result = root.querySelector('[data-pta-dyson-result]');
      const scope = root.closest('.pta-dyson-gen');

      const render = () => {
        scope.querySelectorAll('.is-match').forEach((el) => el.classList.remove('is-match'));
        result.replaceChildren();
        result.removeAttribute('data-state');
        const raw = input.value.trim();
        const query = norm(raw);
        if (query.length < 2) return;

        const match = find(gens, query);
        if (!match) {
          if (query.length < 4) return;
          result.dataset.state = 'none';
          result.textContent = fill(root.dataset.msgNone, { code: raw.toUpperCase() });
          const contact = document.createElement('a');
          contact.href = root.dataset.contactUrl;
          contact.className = 'pta-dyson-gen__go';
          contact.textContent = root.dataset.msgContact;
          result.append(' ', contact);
          return;
        }

        const values = { code: match.code, platform: match.gen.name };
        let state = 'fits';
        let template = root.dataset.msgFits;
        if (match.excluded) {
          state = 'excluded';
          template = root.dataset.msgExcluded;
        } else if (match.gen.current) {
          state = 'here';
          template = root.dataset.msgHere;
        }
        result.dataset.state = state;
        result.append(fill(template, values));

        if (state === 'fits') {
          const link = document.createElement('a');
          link.href = match.gen.url;
          link.className = 'pta-dyson-gen__go';
          link.textContent = fill(root.dataset.msgGo, values);
          result.append(' ', link);
        }

        let card = null;
        scope.querySelectorAll('[data-pta-dyson-gen]').forEach((el) => {
          if (el.dataset.ptaDysonGen === match.gen.name) card = el;
        });
        if (card) card.classList.add('is-match');
        const chipScope = card || scope;
        chipScope.querySelectorAll('[data-code]').forEach((chip) => {
          if (chip.dataset.code === norm(match.code)) chip.classList.add('is-match');
        });
      };

      input.addEventListener('input', render);
      root.hidden = false;

      const preset = new URLSearchParams(window.location.search).get('model');
      if (preset) {
        input.value = preset;
        render();
      }
    };

    const boot = () => document.querySelectorAll('[data-pta-dyson-lookup]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
